import {getInvertedColor} from '../shared/utils';
import {socialIconsFontClasses, socialMediaNamesArray} from '../shared/social-media';
import {
    CONTACT_BUTTON_TYPES, getAddToContactIconColor,
    getContactButton,
    getHeaderCode,
    getInitials,
    getLeadFormHtml,
    setTypography
} from './templateUtils';
import {LanguageService} from '../global-components/notification-language/language.service';
import {CONTACT_DETAIL} from '../digital-business-card/digital-business-card-utils';

function populateDropdown(card, multiLangList, currentLanguage, color?: string) {
    let dropDownHTML = `<div class="language-dropdown" style="background-color: ${color}"><div class="beaconstac-dbc-language-dropdown-container" id="language-dropdown-container">
    <select class="beaconstac-dbc-language-dropdown"  name="language-dropdown" id="language-selector-1" autocomplete="off" disabled>`

    const languageService = new LanguageService();
    const languages = languageService.getLanguagesByCodes(multiLangList);
    const currentLanguageName = languageService.getLanguageByCode(currentLanguage);
    languages.forEach((language) => {
        const isSelected = language === currentLanguageName ? 'selected' : '';

        dropDownHTML += `<option value="${language}" ${isSelected}>${language}</option>`;
    });
    dropDownHTML += `let multiLangDropDownHTML;
    if (isMultiLanguageContent) {
        multiLangDropDownHTML = populateDropdown(card, multiLangList, currentLanguage, card.customizations.background_color);
    } else {
        multiLangDropDownHTML = '';
    }</select>
    <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
        <path d="M6.41843 8.87328L1.92793 4.42286C1.71136 4.20822 1.71136 3.86023 1.92793 3.64562L2.45168 3.12655C2.66788 2.91228 3.01828 2.91187 3.23499 3.12563L6.81056 6.65267L10.3861 3.12563C10.6028 2.91187 10.9532 2.91228 11.1694 3.12655L11.6932 3.64562C11.9097 3.86026 11.9097 4.20824 11.6932 4.42286L7.20269 8.87328C6.98612 9.0879 6.635 9.0879 6.41843 8.87328Z" fill="white"/>
    </svg>
</div></div>`;
    return dropDownHTML;
}

// Icons which are not present in font-awesome
function getCustomColoredSocialIconSvg(name, backgroundColor, color) {

    switch (name) {
        case 'wistia':
            return `<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" width="14" height="14" viewBox="0 0 34.4 26.78">
                      <g id="Wistia_Logos" data-name="Wistia Logos">
                        <path id="Wistia_Flags_One_Color_White" data-name="Wistia Flags One Color White" class="cls-1" d="m16.09,17.1h-5.2c-1.58,0-3.08.68-4.11,1.87L.21,26.53c4.78.25,9.78.25,13.3.25,18.31,0,20.89-11.27,20.89-16.55-1.59,1.93-6.06,6.87-18.32,6.87ZM32.14,0c-.08.92-.59,4.69-11.31,4.69-8.72,0-12.24,0-20.83-.17l6.44,7.4c1.25,1.44,3.05,2.28,4.96,2.3,2.13.03,5.05.06,5.53.06,11.01,0,17.19-5.05,17.19-9.89,0-2.01-.67-3.44-1.97-4.4Z" fill="${color}" stroke-width="0"/>
                      </g>
                    </svg>`;
        case 'custom_url':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 121 120" fill="none">
                        <circle cx="60.1324" cy="60" r="56.4849" stroke="${color}" stroke-width="7.03025"/>
                        <path d="M60.1324 115.055C75.3964 115.055 87.7703 90.4061 87.7703 60C87.7703 29.5938 75.3964 4.94482 60.1324 4.94482" stroke="${color}" stroke-width="7.03025"/>
                        <path d="M60.1324 115.055C44.8685 115.055 32.4946 90.4061 32.4946 60C32.4946 29.5938 44.8685 4.94482 60.1324 4.94482" stroke="${color}" stroke-width="7.03025"/>
                        <line x1="58.7748" y1="4.94482" x2="58.7748" y2="115.055" stroke="${color}" stroke-width="7.03025"/>
                        <path d="M103.237 23.7741C93.1503 30.1372 77.5903 34.2163 60.1325 34.2163C43.15 34.2163 27.9634 30.3563 17.8643 24.2886" stroke="${color}" stroke-width="7.03025"/>
                        <path d="M102.481 95.5492C92.3826 89.4535 77.1603 85.5729 60.1324 85.5729C43.1045 85.5729 27.8822 89.4535 17.7833 95.5492" stroke="${color}" stroke-width="7.03025"/>
                        <line x1="5.07733" y1="61.3579" x2="115.188" y2="61.3579" stroke="${color}" stroke-width="7.03025"/>
                    </svg>`;
        case 'calendly':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 120 123" fill="none">
                        <g clip-path="url(#clip0_772_93)">
                            <path d="M82.1752 79.6035C78.2922 83.0373 73.4735 87.312 64.6782 87.312H59.415C53.0524 87.312 47.2746 84.9995 43.1343 80.8182C39.0875 76.7303 36.8655 71.1474 36.8655 65.074V57.9027C36.8655 51.8293 39.0875 46.2464 43.1343 42.1585C47.2746 37.9772 53.0524 35.6646 59.415 35.6646H64.6548C73.4501 35.6646 78.269 39.9394 82.1521 43.3732C86.1755 46.9238 89.6606 50.0073 98.9004 50.0073C100.351 50.0073 101.754 49.8905 103.111 49.6802C103.111 49.6569 103.088 49.6335 103.088 49.6101C102.526 48.2553 101.895 46.9005 101.146 45.6157L94.9472 34.9172C89.2629 25.0829 78.7603 19.0328 67.4152 19.0328H55.0407C43.6723 19.0328 33.1696 25.0829 27.5088 34.9172L21.3098 45.6157C15.6256 55.45 15.6256 67.5501 21.3098 77.3843L27.5088 88.0829C33.193 97.9171 43.6957 103.967 55.0407 103.967H67.4152C78.7837 103.967 89.2863 97.9171 94.9472 88.0829L101.146 77.3843C101.895 76.0996 102.55 74.7447 103.088 73.3899C103.088 73.3665 103.111 73.3432 103.111 73.3198C101.731 73.1096 100.327 72.9928 98.9004 72.9928C89.6606 72.9694 86.1986 76.0295 82.1752 79.6035Z" fill="${color}"/>
                            <path d="M64.6783 42.1819H59.4152C49.7544 42.1819 43.3918 49.0729 43.3918 57.9027V65.074C43.3918 73.9038 49.7544 80.7948 59.4152 80.7948H64.6547C78.7366 80.7948 77.6372 66.4522 98.9237 66.4522C100.959 66.4522 102.971 66.6391 104.936 67.0128C105.591 63.3688 105.591 59.6313 104.936 55.9872C102.971 56.361 100.959 56.5478 98.9237 56.5478C77.6606 56.5245 78.7602 42.1819 64.6783 42.1819Z" fill="${color}"/>
                            <path d="M117.169 72.2686C113.544 69.5823 109.357 67.8537 104.936 67.0128C104.936 67.0595 104.936 67.0828 104.912 67.1296C104.538 69.2319 103.953 71.3109 103.134 73.3198C106.854 73.9271 110.292 75.3287 113.24 77.4777C113.24 77.5011 113.216 77.5478 113.216 77.5712C111.532 83.0606 108.959 88.2464 105.637 92.9649C102.339 97.6134 98.339 101.725 93.7776 105.135C84.2805 112.236 72.9825 115.997 61.076 115.997C53.7076 115.997 46.5729 114.549 39.836 111.722C33.3331 108.989 27.5088 105.042 22.5029 100.043C17.497 95.0439 13.5672 89.2041 10.807 82.7336C7.95316 76.0294 6.52619 68.8815 6.52619 61.5233C6.52619 54.1652 7.97655 47.0406 10.807 40.3131C13.5438 33.8192 17.497 28.0027 22.5029 23.0039C27.5088 18.0049 33.3565 14.0806 39.836 11.3242C46.5495 8.47438 53.7076 7.04947 61.076 7.04947C72.9825 7.04947 84.2805 10.8103 93.7776 17.9115C98.339 21.3454 102.339 25.4332 105.637 30.0817C108.982 34.8003 111.532 39.9627 113.216 45.4755C113.216 45.4989 113.24 45.5456 113.24 45.5689C110.292 47.718 106.854 49.1195 103.134 49.7269C103.93 51.7358 104.538 53.8148 104.912 55.9171C104.912 55.9405 104.912 55.9872 104.936 56.0105C109.357 55.193 113.52 53.441 117.169 50.7547C120.655 48.1852 119.977 45.2653 119.439 43.5367C111.766 18.6357 88.538 0.532227 61.076 0.532227C27.345 0.532227 0.0233154 27.8392 0.0233154 61.5C0.0233154 95.1607 27.3684 122.468 61.076 122.468C88.538 122.468 111.766 104.364 119.439 79.4633C119.977 77.7347 120.655 74.8381 117.169 72.2686Z" fill="${color}"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_772_93">
                                <rect width="120" height="121.935" fill="white" transform="translate(0 0.532227)"/>
                            </clipPath>
                        </defs>
                        </svg>`;
        case 'cashapp':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 121 120" fill="none">
                        <g clip-path="url(#clip0_771_59)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M64.7611 28.7146C74.0883 28.7146 83.0281 32.4915 88.8691 37.6755C90.3465 38.9873 92.5578 38.9792 93.9443 37.5743L100.894 30.5254C102.36 29.0377 102.307 26.6019 100.723 25.2424C96.0597 21.2333 89.7988 17.2909 82.093 14.7669L84.2728 4.38753C84.7453 2.12523 83.0227 -0.000854492 80.7097 -0.000854492H67.2798C65.5626 -0.000854492 64.0776 1.2011 63.7198 2.8811L61.7565 12.1119C43.904 13.004 28.7731 21.9115 28.7731 40.1888C28.7731 56.0118 41.2917 62.7933 54.5047 67.486C67.0238 72.179 73.6289 73.9205 73.6289 80.5257C73.6289 87.3072 67.0238 91.3059 57.2853 91.3059C48.4072 91.3059 39.1069 88.3755 31.8898 81.2601C30.4741 79.8633 28.2092 79.8525 26.7935 81.2497L19.3257 88.6163C17.8646 90.0558 17.8781 92.4224 19.3496 93.8485C25.1726 99.5 32.5441 103.592 40.9578 105.884L38.9089 115.499C38.431 117.754 40.1379 119.88 42.4455 119.898L55.8965 120C57.6272 120.013 59.1307 118.803 59.4835 117.107L61.4253 107.863C82.8009 106.543 95.8833 94.9249 95.8833 77.9188C95.8833 62.2727 82.8463 55.6644 67.0238 50.2747C57.9823 46.9681 50.1563 44.7109 50.1563 37.932C50.1563 31.3269 57.4617 28.7146 64.7611 28.7146Z" fill="${color}"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_771_59">
                                <rect width="120" height="120" fill="white" transform="translate(0.0884399)"/>
                            </clipPath>
                        </defs>
                    </svg>`;
        case 'venmo':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 121 121" fill="none">
                    <g clip-path="url(#clip0_771_56)">
                        <path d="M6.34852 -3.91577C1.68051 3.81058 -0.412049 11.7516 -0.412049 21.7851C-0.412049 53.7636 26.8985 95.3464 49.0581 124.535H99.7087L120.044 3.11306L75.7248 -1.07204L64.9937 85.3129C54.9602 68.9481 42.5658 43.3008 42.5658 25.7556C42.5658 16.1513 44.2291 9.65901 46.7509 4.23982L6.34852 -3.91577Z" fill="${color}"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_771_56">
                            <rect width="120" height="120" fill="white" transform="matrix(-1 0 0 1 120.044 0.30957)"/>
                        </clipPath>
                    </defs>
                </svg>`;
        case 'twitter':
            return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 121 123" fill="none">
                    <g clip-path="url(#clip0_767_44)">
                        <path d="M72.3723 51.8941L117.045 0H106.459L67.6697 45.059L36.6888 0H0.955994L47.8052 68.1371L0.955994 122.556H11.5426L52.5051 74.9723L85.2232 122.556H120.956L72.3697 51.8941H72.3723ZM57.8725 68.7374L53.1257 61.9525L15.3571 7.96418H31.6175L62.0972 51.5345L66.844 58.3194L106.464 114.954H90.2036L57.8725 68.74V68.7374Z" fill="${color}"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_767_44">
                            <rect width="120" height="122.619" fill="white" transform="translate(0.955994)"/>
                        </clipPath>
                    </defs>
                </svg>`;
    }

    return '';
}

function getTwoContactItems(card) {
    let list1 = [];
    let list2 = [];

    for (const contact of card.__contact_info_list__) {
        if (contact.key === 'phone_v2') {
            list1 = contact.value.filter(item => item.value)
        }

        if (contact.key === 'email_v2') {
            list2 = contact.value.filter(item => item.value)
        }
    }

    const phoneIndex = card.__contact_info_list__.findIndex(item => item.key === 'phone_v2')
    const emailIndex = card.__contact_info_list__.findIndex(item => item.key === 'email_v2')

    list1.forEach(function (item) {
        item.type = 'phone';
        item.visited = false; // Initialize visited flag
    });

    list2.forEach(function (item) {
        item.type = 'email';
        item.visited = false; // Initialize visited flag
    });

    // Return one item from phone and one from email_v2 or if any of the list have 0 items return 1 or 2 items from the other list
    if (list1.length > 0 && list2.length > 0) {
        list1[0].visited = true;
        list2[0].visited = true;
        const firstItem = phoneIndex < emailIndex ? list1[0] : list2[0];
        const secondItem = phoneIndex < emailIndex ? list2[0] : list1[0];

        return [firstItem, secondItem];
    } else if (list1.length > 1) {
        list1[0].visited = true;
        list1[1].visited = true;
        return list1.slice(0, 2);
    } else if (list2.length > 1) {
        list2[0].visited = true;
        list2[1].visited = true;
        return list2.slice(0, 2);
    } else if (list1.length === 1) {
        list1[0].visited = true;
        return [list1[0]];
    } else if (list2.length === 1) {
        list2[0].visited = true;
        return [list2[0]];
    }
    return [];
}


function buildHeader(card) {
    let htmlString = `<div class="image-container">
                                    <svg width="100%" viewBox="0 0 246 112" preserveAspectRatio="xMidYMid meet" fill="none" xmlns="http://www.w3.org/2000/svg" style="height: auto; overflow: visible;">
                                        <path d="M246 111.5H171.782C161.477 111.5 152.791 103.603 149.548 93.821C143.168 74.5733 127.252 46.5 88.6879 46.5C50.1241 46.5 34.2079 74.5733 27.8273 93.821C24.5848 103.603 15.8992 111.5 5.59416 111.5H0V0H246V111.5Z" fill="${card.customizations.background_color}"/>`
    if (card.user_image_url) {
        htmlString += `<image href="${card.user_image_url}"  x="40" y="58" height="98" width="98"  clip-path="inset(0% round 50%)" />`
    } else {
        htmlString += `<circle cx="89" cy="104" r="50" fill="${card.customizations.background_color}" fill-opacity="0.2" />
                            <text x="87" y="102" dominant-baseline="middle" text-anchor="middle" fill="${card.customizations.background_color}" font-size="24px">${getInitials(card)}</text>`
    }

    const parentWidth = 246;
    const logoPosition = parentWidth - (card.logo_size  + 10);

    if (card.logo_url) {
        htmlString += `<image href="${card.logo_url}" x="${logoPosition}" y="16"  style="height: auto" width="${card.logo_size}px" />`
    }

    htmlString += '</svg></div>';
    return htmlString;
}

function buildInfo(card) {
    let html = `<div class="info">
                            <span class="user-name personal_info">
                                  <span>${ card.prefix ? card.prefix : '' } ${ card.first_name } ${ card.last_name ? card.last_name : ''} ${ card.suffix ? card.suffix : '' } &nbsp;</span>
                                  ${card.pronouns_v2 ? `<span class="user-name pronunciation" id="pronouns">(${card.pronouns_v2})</span>` : ''}
                            </span>`
    if (card.designation) {
        html += `<span class="designation multi-line company_details">${card.designation}&nbsp;</span>`
    }

    if (card.department) {
        html += `<span class="designation company_details">${card.department}&nbsp;</span>`
    }

    if (card.company) {
        html += `<br><span class="company company_details">${card.company}</span>`
    }

    html += '</div>'
    return html;
}

function buildContact(card) {

    const items = getTwoContactItems(card);

    if (items.length === 0) {
        return '';
    }


    const html = `<div class="contact">
                ${items.filter(item => item.value).map(item => `
                        <div class="contact-box">
                            ${item.type === 'phone' ?
        `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 34 32" fill="none">
                                    <path d="M23.7354 16C27.4552 16 30.4708 13.0152 30.4708 9.33329C30.4708 5.6514 27.4552 2.66663 23.7354 2.66663C20.0156 2.66663 17 5.6514 17 9.33329C17 10.3997 17.253 11.4077 17.7028 12.3016C17.8224 12.5392 17.8621 12.8107 17.7929 13.067L17.3917 14.551C17.2176 15.1953 17.813 15.7846 18.4639 15.6122L19.9632 15.2152C20.2222 15.1466 20.4965 15.186 20.7365 15.3044C21.6396 15.7496 22.658 16 23.7354 16Z" stroke="${card.customizations.icon_color}" stroke-width="2"/>
                                    <path d="M23.7354 12V6.66663M26.4296 9.33329H21.0413" stroke="${card.customizations.icon_color}" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M4.54201 10.5676C4.51211 10.0161 4.03619 9.59302 3.47901 9.62262C2.92183 9.65222 2.4944 10.1233 2.52431 10.6748L4.54201 10.5676ZM5.84309 5.45612C5.45882 5.85656 5.47527 6.4895 5.87984 6.86986C6.28441 7.25021 6.92388 7.23393 7.30816 6.83349L5.84309 5.45612ZM13.8534 27.7497C14.3258 28.0435 14.9495 27.9027 15.2464 27.4351C15.5433 26.9675 15.4009 26.3502 14.9285 26.0563L13.8534 27.7497ZM19.8464 28.0778C19.3003 27.9646 18.7648 28.3111 18.6504 28.8517C18.5361 29.3922 18.886 29.9222 19.4323 30.0354L19.8464 28.0778ZM20.5625 22.0582L21.1759 21.4189L19.7109 20.0415L19.0974 20.6809L20.5625 22.0582ZM23.1948 21.1497L25.7684 22.6159L26.7764 20.8826L24.2028 19.4163L23.1948 21.1497ZM26.2651 25.6558L24.3515 27.6499L25.8166 29.0273L27.7302 27.0333L26.2651 25.6558ZM10.7485 22.6115C5.52703 17.1703 4.65118 12.5807 4.54201 10.5676L2.52431 10.6748C2.658 13.1404 3.7157 18.187 9.28341 23.9889L10.7485 22.6115ZM12.6012 13.7621L12.9875 13.3594L11.5225 11.9821L11.1361 12.3847L12.6012 13.7621ZM13.2911 8.34677L11.5924 5.96878L9.94252 7.12341L11.6412 9.50138L13.2911 8.34677ZM11.8686 13.0734C11.1361 12.3847 11.1352 12.3857 11.1342 12.3866C11.1339 12.387 11.133 12.388 11.1323 12.3886C11.131 12.39 11.1297 12.3914 11.1284 12.3928C11.1258 12.3956 11.123 12.3986 11.1202 12.4016C11.1145 12.4078 11.1086 12.4144 11.1022 12.4216C11.0897 12.436 11.0758 12.4524 11.061 12.4709C11.0314 12.5079 10.9979 12.5534 10.9627 12.6078C10.8923 12.7168 10.8158 12.8604 10.7511 13.0404C10.6195 13.4065 10.5478 13.8913 10.6374 14.4967C10.8135 15.6862 11.6009 17.2858 13.6584 19.4298L15.1235 18.0525C13.2003 16.0483 12.7266 14.8141 12.6367 14.2067C12.5933 13.9138 12.6374 13.7594 12.6548 13.7109C12.6646 13.6837 12.671 13.6761 12.6648 13.6858C12.6617 13.6905 12.6556 13.6993 12.6455 13.7121C12.6404 13.7183 12.6342 13.7258 12.6269 13.7341C12.6232 13.7383 12.6193 13.7427 12.615 13.7474C12.6128 13.7497 12.6106 13.7521 12.6083 13.7545C12.6072 13.7558 12.606 13.757 12.6048 13.7582C12.6042 13.7589 12.6033 13.7598 12.603 13.7602C12.6021 13.7611 12.6012 13.7621 11.8686 13.0734ZM13.6584 19.4298C15.7098 21.5675 17.2592 22.4079 18.4412 22.5979C19.0477 22.6954 19.5387 22.6175 19.9105 22.4725C20.0922 22.4015 20.2361 22.3182 20.344 22.2425C20.3977 22.2046 20.4426 22.1687 20.4788 22.1374C20.4969 22.1217 20.5129 22.107 20.5268 22.0937C20.5338 22.0871 20.5401 22.0807 20.5461 22.0749C20.549 22.0719 20.552 22.069 20.5547 22.0662C20.556 22.0649 20.5574 22.0635 20.5586 22.0622C20.5593 22.0615 20.5602 22.0605 20.5606 22.0602C20.5615 22.0591 20.5625 22.0582 19.8299 21.3695C19.0974 20.6809 19.0983 20.6799 19.0992 20.679C19.0996 20.6786 19.1004 20.6777 19.101 20.677C19.1023 20.6758 19.1035 20.6746 19.1045 20.6734C19.107 20.671 19.1093 20.6686 19.1115 20.6663C19.116 20.6619 19.1203 20.6577 19.1243 20.6538C19.1326 20.6461 19.1398 20.6394 19.1463 20.6338C19.1592 20.6226 19.1688 20.6154 19.175 20.6111C19.1875 20.6022 19.1863 20.6053 19.1691 20.6119C19.1431 20.6221 19.0208 20.6649 18.7651 20.6238C18.2229 20.5366 17.0527 20.0629 15.1235 18.0525L13.6584 19.4298ZM11.5924 5.96878C10.227 4.05734 7.49485 3.73486 5.84309 5.45612L7.30816 6.83349C8.01245 6.09956 9.25235 6.15721 9.94252 7.12341L11.5924 5.96878ZM24.3515 27.6499C23.9756 28.0417 23.5824 28.2515 23.2001 28.2889L23.3986 30.2793C24.4049 30.1809 25.2193 29.6497 25.8166 29.0273L24.3515 27.6499ZM12.9875 13.3594C14.2909 12.0012 14.3832 9.87565 13.2911 8.34677L11.6412 9.50138C12.2098 10.2975 12.1226 11.3566 11.5225 11.9821L12.9875 13.3594ZM25.7684 22.6159C26.8742 23.2459 27.0906 24.7957 26.2651 25.6558L27.7302 27.0333C29.4881 25.2014 28.9761 22.1358 26.7764 20.8826L25.7684 22.6159ZM21.1759 21.4189C21.6951 20.8778 22.5042 20.7562 23.1948 21.1497L24.2028 19.4163C22.7231 18.5733 20.8879 18.815 19.7109 20.0415L21.1759 21.4189ZM14.9285 26.0563C13.6033 25.2321 12.1929 24.1167 10.7485 22.6115L9.28341 23.9889C10.838 25.6089 12.3781 26.8321 13.8534 27.7497L14.9285 26.0563ZM23.2001 28.2889C22.4639 28.3609 21.2988 28.3789 19.8464 28.0778L19.4323 30.0354C21.1141 30.3839 22.4883 30.3682 23.3986 30.2793L23.2001 28.2889Z" fill="${card.customizations.icon_color}"/>
                                </svg>`
        :
        `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 34 32" fill="none">
                                    <path d="M14.3059 25.3333H9.187C7.67813 25.3333 6.92369 25.3333 6.34738 25.0427C5.84043 24.7871 5.42828 24.3791 5.16999 23.8773C4.87634 23.3069 4.87634 22.5601 4.87634 21.0667V10.9333C4.87634 9.43987 4.87634 8.69312 5.16999 8.12269C5.42828 7.62092 5.84043 7.21297 6.34738 6.95732C6.92369 6.66667 7.67813 6.66667 9.187 6.66667H24.8131C26.322 6.66667 27.0765 6.66667 27.6528 6.95732C28.1597 7.21297 28.5719 7.62092 28.8301 8.12269C29.1238 8.69312 29.1238 9.43987 29.1238 10.9333V13.3333M28.594 11.0164L21.782 15.5113C20.0537 16.6517 19.1896 17.222 18.2555 17.4436C17.43 17.6393 16.5695 17.6393 15.7442 17.4436C14.8101 17.222 13.9459 16.6517 12.2176 15.5113L5.07498 10.7982M19.6942 28L22.422 27.46C22.6598 27.4129 22.7788 27.3893 22.8896 27.3463C22.9881 27.3081 23.0817 27.2585 23.1683 27.1987C23.2661 27.1312 23.3518 27.0464 23.5234 26.8765L29.1238 21.3333C29.8678 20.5969 29.8678 19.4031 29.1238 18.6667C28.3798 17.9303 27.1736 17.9303 26.4296 18.6667L20.8293 24.2099C20.6576 24.3797 20.572 24.4645 20.5038 24.5613C20.4433 24.6471 20.3932 24.7397 20.3547 24.8372C20.3112 24.9469 20.2873 25.0647 20.2398 25.3L19.6942 28Z" stroke="${card.customizations.icon_color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>`
}
                            <span class="contact-title contact_details" >${item.value}</span>
                            <span class="contact-label contact_details">${item.label}</span>
                        </div>
                        `).join('')}
                    </div>`;
    return html;
}

function buildAddToContactButton(card) {
    let contactBtn = '';
    if (card.__show_new_sticky_btn__ && card.lead_collection) {
        contactBtn = getContactButton(CONTACT_BUTTON_TYPES.EXCHANGE_CONTACTS, card);
    }  else {
        contactBtn = getContactButton(CONTACT_BUTTON_TYPES.ADD_TO_CONTACTS, card);
    }
    return `<div class="add-to-contact" style="background-color: ${ card.customizations.button_color }">
                         ${contactBtn}
                    </div>`
}

function buildSummary(card) {
    return `<div class="summary-container">
                            <p class="secondary_data bio" style="white-space: pre-line ; word-break: break-word;">${card.summary}</p>
                        </div>`
}

function buildPhoneContact(card) {

    for (const contact of card.__contact_info_list__) {
        if (contact.key === 'phone_v2') {
            return contact.value.filter(item => (!item.visited && item.value)).map(item => `
                            <div class="contact-phone">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M12.1492 4.44035C12.9909 4.60425 13.7644 5.01511 14.3708 5.62033C14.9772 6.22556 15.3888 6.99761 15.5531 7.83769M12.1492 1C13.8979 1.19389 15.5286 1.97549 16.7735 3.21645C18.0184 4.45741 18.8035 6.08398 19 7.82909M18.1383 14.6926V17.2728C18.1392 17.5124 18.0901 17.7495 17.9939 17.969C17.8978 18.1884 17.7568 18.3854 17.5799 18.5474C17.4031 18.7093 17.1943 18.8326 16.967 18.9093C16.7396 18.9861 16.4987 19.0146 16.2597 18.993C13.608 18.7054 11.0608 17.8011 8.82292 16.3526C6.74082 15.032 4.97557 13.2701 3.65252 11.192C2.19617 8.94824 1.28985 6.3936 1.00699 3.73508C0.98546 3.49723 1.01378 3.25752 1.09015 3.0312C1.16652 2.80488 1.28927 2.59691 1.45059 2.42054C1.6119 2.24416 1.80824 2.10324 2.02711 2.00675C2.24598 1.91026 2.48258 1.86031 2.72185 1.86009H5.30705C5.72525 1.85598 6.13069 2.00379 6.44778 2.27597C6.76487 2.54815 6.97198 2.92612 7.03051 3.33944C7.13963 4.16518 7.34199 4.97595 7.63373 5.75628C7.74967 6.06413 7.77476 6.39869 7.70603 6.72034C7.63731 7.04198 7.47764 7.33722 7.24595 7.57106L6.15155 8.66337C7.37827 10.8166 9.16456 12.5995 11.3219 13.8239L12.4164 12.7316C12.6506 12.5003 12.9465 12.341 13.2687 12.2724C13.591 12.2038 13.9262 12.2288 14.2346 12.3445C15.0164 12.6357 15.8288 12.8377 16.6561 12.9466C17.0747 13.0055 17.457 13.216 17.7303 13.5379C18.0035 13.8598 18.1488 14.2708 18.1383 14.6926Z" stroke=${card.customizations.icon_color} stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="flex-align-col-left contact-val-container">
                                    <span class="contact-value contact_details" >
                                        ${item.value}
                                    </span>
                                    <span class="contact-label contact_details">
                                        ${item.label}
                                    </span>
                                </div>
                            </div>
                        `).join('');
        }
    }
}
function buildEmailContact(card) {
    for (const contact of card.__contact_info_list__) {
        if (contact.key === 'email_v2') {
            return contact.value.filter(item => (!item.visited && item.value)).map(item => `
                            <div class="contact-email">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 18" fill="none">
                                    <path d="M16.875 3.26999H1.125V14.7225H16.875V3.26999Z" stroke=${card.customizations.icon_color } stroke-miterlimit="10"/>
                                    <path d="M1.125 3.26999L9 11.145L16.875 3.26999" stroke=${ card.customizations.icon_color } stroke-miterlimit="10"/>
                                </svg>
                                <div class="flex-align-col-left contact-val-container">
                                    <span class="contact-value contact_details" >
                                        ${item.value}
                                    </span>
                                    <span class="contact-label contact_details">
                                        ${item.label}
                                    </span>
                                </div>
                            </div>
                        `).join('');
        }
    }
}
function buildWebsiteContact(card) {
    for (const contact of card.__contact_info_list__) {
        if (contact.key === 'website_v2') {
            return contact.value.filter( item => item.value).map(item => `
                            <div class="contact-website">
                                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="30" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z" stroke=${ card.customizations.icon_color } stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M1 10H19" stroke=${ card.customizations.icon_color } stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.0001 1C12.2512 3.46452 13.5306 6.66283 13.6001 10C13.5306 13.3372 12.2512 16.5355 10.0001 19C7.74893 16.5355 6.46961 13.3372 6.40009 10C6.46961 6.66283 7.74893 3.46452 10.0001 1V1Z" stroke=${ card.customizations.icon_color } stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="flex-align-col-left contact-val-container">
                                    <span class="contact-value contact_details" >
                                        ${item.value}
                                    </span>
                                    <span class="contact-label contact_details">
                                        ${item.label}
                                    </span>
                                </div>
                            </div>
                        `).join('');
        }
    }
}

function buildCustomContact(card) {
    for (const contact of card.__contact_info_list__) {
        if (contact.key === 'custom_fields') {
            return contact.value.filter(item => item.value.trim()).map(item => `
                            <div class="contact-website">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M9.03125 18.5714H9.8125V12.9286H9.03125C8.59977 12.9286 8.25 12.5788 8.25 12.1473V10.2812C8.25 9.84977 8.59977 9.5 9.03125 9.5H13.4062C13.8377 9.5 14.1875 9.84977 14.1875 10.2812V18.5714H14.9688C15.4002 18.5714 15.75 18.9212 15.75 19.3527V21.2188C15.75 21.6502 15.4002 22 14.9688 22H9.03125C8.59977 22 8.25 21.6502 8.25 21.2188V19.3527C8.25 18.9212 8.59977 18.5714 9.03125 18.5714ZM12 2C10.4467 2 9.1875 3.25918 9.1875 4.8125C9.1875 6.36582 10.4467 7.625 12 7.625C13.5533 7.625 14.8125 6.36582 14.8125 4.8125C14.8125 3.25918 13.5533 2 12 2Z" stroke="${card.customizations.icon_color}" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                <div class="flex-align-col-left contact-val-container">
                                    <span class="contact-value contact_details" >
                                        ${item.value}
                                    </span>
                                    <span class="contact-label contact_details">
                                        ${item.label}
                                    </span>
                                </div>
                            </div>
                        `).join('');
        }
    }
}

function buildAddressContact(card) {
    if (!card.address_v2) {
        return '';
    }
    return `<div class="contact-website">
                 <svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path xmlns="http://www.w3.org/2000/svg" d="M11.2292 21.5965C5.55352 13.3684
                                    4.5 12.5239 4.5 9.5C4.5 5.35785 7.85785 2 12 2C16.1421 2 19.5 5.35785
                                    19.5 9.5C19.5 12.5239 18.4465 13.3684 12.7708 21.5965C12.3983 22.1345
                                    11.6016 22.1345 11.2292 21.5965ZM12 12.625C13.7259 12.625 15.125 11.2259
                                    15.125 9.5C15.125 7.7741 13.7259 6.375 12 6.375C10.2741 6.375 8.875 7.7741 8.87
                                    9.5C8.875 11.2259 10.2741 12.625 12 12.625Z" stroke="${card.customizations.icon_color}" stroke-width="1" />
                                </svg>
                <div class="flex-align-col-left">
                    <span class="contact-value contact_details" >
                        ${card.address_v2}
                    </span>
                    <span class="contact-label contact_details">
                        Address
                    </span>
                </div>
            </div>
                        `;
}

function buildSocialIcons(card) {

    const iconColor = getInvertedColor(card.customizations.icon_color);

    let html = '<div class="social-icons">';

    for (const name of socialMediaNamesArray) {
        if (!card.social_links[name]) {
            continue;
        }

        if (socialIconsFontClasses[name]) {
            html += `<div class="svg-container" style="background-color: ${card.customizations.icon_color}"><i class="fab ${socialIconsFontClasses[name]}" style="color: ${iconColor}"></i></div>`;
        } else {
            const svgIconCode = getCustomColoredSocialIconSvg(name, card.customizations.icon_color, iconColor);
            html += `<div class="svg-container" style="background-color: ${card.customizations.icon_color}">`;
            html += svgIconCode;
            html += '</div>';

        }
    }
    html += '</div>';
    return html;
}

function buildShareYourContactBtn(card) {
    if (!card.lead_collection) {
        return '';
    }
    return `<div id="leadPrimarylBtn" class="share-contact-btn button" style="border: 1px solid ${card.customizations.button_color}; color: ${card.customizations.button_color};">
                        <span> Share your contact </span>
                    </div>`;
}


function buildTemplate(card) {
    let htmlDocString = `
        <style>
            body {
                    font-family: 'Open Sans', sans-serif;
                }

                @media only screen and (device-width: 500px) {
                    .mobile-layout {
                        max-width: 100% !important;
                        width: 100%;
                    }
                }

                .container {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    max-width: 450px;
                }

                .layout {
                    max-width: 450px;
                    min-width: 300px;
                    width: 100%;
                    zoom: 0.75;
                    min-height: 100%;
                }

                .details-container {
                    margin-left: 16px;
                    margin-right: 16px;
                    margin-top: 10px;
                    padding-bottom: 16px;
                    padding-left: 2px;
                    padding-right: 2px;
                }

                .image-container {
                    min-height: 200px;
                    width: 100%;

                    svg {
                        overflow: visible;
                    }
                }

                .profile-image {
                    border-radius: 50%;
                    width: 96px;
                    height: 97px;
                    flex-shrink: 0;
                    object-fit: contain;

                    img {
                        border-radius: 50%;
                        width: 100%;
                        height: 100%;
                    }
                }

                .contact {
                    overflow: scroll;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: row;
                    margin-top: 24px;
                    aspect-ratio: 2/1;
                    padding: 2px;
                }

                .contact-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 42%;
                    flex-direction: column;
                    gap: 8px;
                    flex-shrink: 0;
                    box-shadow: 0px 2px 8px 0px rgba(129, 132, 136, 0.15);
                    border-radius: 8px;
                    background: #FFF;
                    padding: 0px 8px;
                }

                .contact-title {
                        text-align: center;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                }

                .info-container {
                    padding: 12px 0px;
                }

                .user-name {
                    display: flex;
                    flex-wrap: wrap;
                    font-style: normal;
                    line-height: normal;
                    margin-bottom: 4px;
                    align-items: center;
                }

                .pronunciation {
                    font-style: italic;
                    font-weight: 400;
                    opacity: 0.4;
                }

                .designation, .company {
                    font-style: normal;
                    line-height: normal;
                }

                .multi-line {
                    white-space: pre-line;
                }

                .contact-label {
                    opacity: 0.5;
                    text-align: center;
                    font-style: normal;
                    line-height: normal;
                }


                .flex-align-col-left {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                }


                .add-to-contact {
                    display: flex;
                    height: 40px;
                    padding: 8px 16px;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    border-radius: 100px;
                    color: #ffffff;
                    margin-top: 12px;
                }

                .share-contact-btn {
                    display: flex;
                    height: 40px;
                    padding: 8px 16px;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                    border-radius: 100px;
                    background: transparent;
                    margin-top: 24px;
                    cursor: pointer;
                }

                .summary-container {
                     margin-top: 24px;
                }

                .contact-fields {
                    margin-top: 24px;
                    display: flex;
                    flex-direction: column;
                    row-gap: 16px;
                }

                .contact-email, .contact-phone, .contact-website {
                    display: flex;
                    padding: 12px 16px;
                    align-items: center;
                    gap: 16px;
                    border-radius: 32px;
                    background: #FFF;
                    box-shadow: 0px 2px 8px 0px rgba(129, 132, 136, 0.15);
                    min-height: 40px;

                    color: #1B8383;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                }

                .social-icons {
                    margin-top: 24px;
                    align-items: center;
                    padding-left: 4px;
                    padding-right: 4px;
                    justify-items: center;
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(40px, max-content));
                    justify-content: center;
                    column-gap: 16px;
                }

                .language-dropdown {
                    position: relative;
                    z-index: 1;
                    display: flex;
                    flex-direction: row-reverse;
                }

                .svg-container {
                    margin-top: 12px;
                     height: 30px;
                     width: 30px;
                     border-radius: 50%;
                     display: flex;
                     align-items: center;
                     justify-content: center;

                     i {
                     font-size: 14px;
                     }
                }

                .btn-contact-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .contact-val-container {
                    overflow: hidden;
                    max-width: 86%;
                    .contact_details {
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                @media screen and (min-width: 300px) and (max-width: 400px) {
                    .image-container {
                        margin-bottom: 12%;
                    }
                }

                .flex-center {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .btn-download {
                    display: flex;
                    justify-content: center;
                    padding: 10px;
                    text-decoration: none;
                }

                .exchange-button {
                    padding-left: 16px;
                }

                #exchange-contact-icon {
                    color: ${getAddToContactIconColor(card.customizations.typography)};
                }
                /* Override server side added, css styles */
                .btn-container {
                    cursor: unset !important;
                }
        </style>`;
    htmlDocString += buildHeader(card);

    htmlDocString += `
                    <div class="details-container">
                        <div class="info-container">`;
    htmlDocString += buildInfo(card);
    htmlDocString += buildContact(card);
    htmlDocString += '</div>'; // info-container end


    htmlDocString += buildAddToContactButton(card);
    htmlDocString += buildSummary(card);

    htmlDocString += '<div class="contact-fields">'

    card.__contact_info_list__.forEach((contact) => {
        switch (contact.key) {
            case CONTACT_DETAIL.PHONE_V2:
                htmlDocString += buildPhoneContact(card)
                break;
            case CONTACT_DETAIL.EMAIL_V2:
                htmlDocString += buildEmailContact(card)
                break;
            case CONTACT_DETAIL.WEBSITE_V2:
                htmlDocString += buildWebsiteContact(card)
                break;
            case CONTACT_DETAIL.CUSTOM_FIELDS:
                htmlDocString += buildCustomContact(card)
                break;
        }
    })

    htmlDocString += buildAddressContact(card)
    htmlDocString += '</div>' // contact-fields end

    htmlDocString += buildSocialIcons(card)

    if (!card.__show_new_sticky_btn__ && card.lead_collection) {
        htmlDocString += buildShareYourContactBtn(card)
    }


    htmlDocString += getLeadFormHtml(card);
    htmlDocString += '</div>'; // details-container end

    return htmlDocString;
}



export function layout7TemplateHtml(card, isMobile, isMultiLanguageContent = false, multiLangList?, currentLanguage?) {

    let multiLangDropDownHTML;
    if (isMultiLanguageContent) {
        multiLangDropDownHTML = populateDropdown(card, multiLangList, currentLanguage, card.customizations.background_color);
    } else {
        multiLangDropDownHTML = '';
    }

    let headHtmlCode = '<html class="layout-firefox">'
    headHtmlCode += getHeaderCode(card);

    headHtmlCode += `<style>
              html {
                  -ms-overflow-style: none;  /* Internet Explorer 10+ */
                    scrollbar-width: none;  /* Firefox */
                }
                .main-container {
                  -ms-overflow-style: none;  /* Internet Explorer 10+ */
                    scrollbar-width: none;  /* Firefox */
                }
                html::-webkit-scrollbar {
                  width: 0;
                  height: 0;
              }

            .secondary_data {
                color: {{ card.secondary_color }};
            }

            .content {
                font-family: '{{ card.font_style }}', sans-serif;
            }

            .email {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .hidden {
                display: none;
            }

            .beaconstac-dbc-language-dropdown-container {
                .top: 12px;
                right: 14px;
            }
        </style>`;

    let styleCode = '';
    styleCode += setTypography(card);

    headHtmlCode += styleCode;

    headHtmlCode += `<body style="margin: 0" id="body">

     <div id="content-container" style="display: flex; justify-content: center; background-attachment: fixed;">
     <script>
            function setCardBackground(maxRetries = 3) {
                if (maxRetries === 0) {
                    return
                }
                  const container = document.getElementById('content-container');
                  if (!container) {
                      setCardBackground(maxRetries-1)
                      return
                  }
                  const backgroundType = '${card.customizations?.background?.type}';
                  const backgroundValue = '${card.customizations?.background?.value}';

                  if (backgroundType === 'color') {
                      container.style.backgroundColor = backgroundValue;
                  } else if (backgroundValue) {
                      container.style.backgroundImage = "url('" + backgroundValue + "')";
                  }
            }
            setCardBackground()
        </script>
        <div class="layout mobile-layout" id="dbc-layout-container">`;

    headHtmlCode += multiLangDropDownHTML;

    headHtmlCode += buildTemplate(card);
    headHtmlCode += `</div>
    </div>
</body>
</html>`;

    return headHtmlCode;

}

